<template>
  <div>
    <span v-if="usersOnDuty.length > 0" class="mr-6">
      Users on duty:
      <ul >
        <li class="pa-2" :style="getOnDutyBgColor(user)" v-for="user in usersOnDuty" :key="user.user">
          <span :style="getOnDutyColor(user)">{{ user.user }}</span>
        </li>
      </ul>
    </span>
    <span v-else class="mr-6">
      No user on duty
    </span>

    <v-btn v-if="onDuty" @click="toggleOnDuty" color="red" class="mr-6" small :disabled="isDisconnected">Check Out</v-btn>
    <v-btn v-else @click="openAskCheckin" color="primary" class="mr-6" small :disabled="isDisconnected">Check In</v-btn>

    <v-dialog max-width="600px" v-model="askCheckin">
      <v-card>
        <v-card-title>
          <span>Check-in as
            <strong style="color: lightgreen">Primary</strong> or
            <strong style="color: orange">Secondary</strong>
          </span>
        </v-card-title>
        <v-card-actions>
          <v-btn text color="red" @click="askCheckin=false">Cancel</v-btn>
          <v-spacer></v-spacer>

          <v-btn color="green" @click="toggleOnDuty('primary')">Primary</v-btn>
          <v-btn color="orange" @click="toggleOnDuty('secondary')">Secondary</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'onDuty',
      'usersOnDuty'
    ]),
    ...mapState([
      'isDisconnected',
      'userPingData'
    ]),
  },
  data() {
    return {
      askCheckin: false
    }
  },
  methods: {
    toggleOnDuty(type) {
      console.log("toggle", this.$store.state.user);
      this.$store.commit("toggleOnDuty", type);

      this.askCheckin = false;
    },

    openAskCheckin() {
      this.askCheckin = true;
    },

    getOnDutyColor(user) {
      if (user.on_duty_type === 'secondary') {
        return 'color: orange';
      }
      return 'color: lightgreen';
    },

    getOnDutyBgColor(user) {
      let style = 'border-radius: 3px;';

      if (!this.userPingData) return style;

      let gotUser = false;

      for (let i = 0; i < this.userPingData.length; i ++) {
        if (this.userPingData[i].user_id != user._id) {
          continue;
        }

        // got user
        gotUser = true;
      }

      if (!gotUser) {
        style += 'background-color: purple;'
      }

      return style;
    }

  }

}
</script>

<style scoped>
ul {
  list-style: none;
  display: inline;
}

li {
  list-style-type: none;
  display: inline;
  margin-right: 5px;
}
</style>
